import request from 'utils/request';

let indexService = {
    appList:function(data){
        return request('/visitApps')
    },
    // 修改密码
    editPwd:function(data){
        return request('/changePassword',{
            method: 'post',
            headers: { "Content-Type": "application/json;charset=UTF-8" },
            data
        })
    },
    // 获取当前登录用户的信息
    getCurrentAccount(){
        return request('/currentAccount')
    },
    // 退出登录
    logout(params){
        return request('/logout')
    }
};


export default indexService;